import './formats.js';
import { Type } from '@sinclair/typebox';
export const LoginRequestSchema = Type.Object({
    email: Type.String({ format: 'email', maxLength: 320 }),
    password: Type.String({ minLength: 1, maxLength: 1024 }),
});
export const RegisterRequestSchema = Type.Object({
    email: Type.String({ format: 'email', maxLength: 320 }),
    password: Type.String({ minLength: 8, maxLength: 128 }),
}, { additionalProperties: false });
export const JoinWorldRequestSchema = Type.Object({
    playerName: Type.String({ minLength: 1, maxLength: 40, pattern: '\\S' }),
    villageName: Type.String({ minLength: 1, maxLength: 60, pattern: '\\S' }),
}, { additionalProperties: false });
export const AvailableWorldsSchema = Type.Array(Type.Object({
    slug: Type.String(),
    name: Type.String(),
    spawnMode: Type.Optional(Type.Union([Type.Literal('atlas'), Type.Literal('automatic')])),
    joined: Type.Boolean(),
    canJoin: Type.Boolean(),
}));
export const JoinWorldResponseSchema = Type.Object({ villageId: Type.String({ format: 'uuid' }) });
export const AccountSchema = Type.Object({
    id: Type.String({ format: 'uuid' }),
    email: Type.String({ format: 'email' }),
    /** Last version of the release notes the player acknowledged (releases.ts); null until known. */
    lastSeenRelease: Type.Union([Type.String(), Type.Null()]),
});
export const WorldSummarySchema = Type.Object({
    id: Type.String({ format: 'uuid' }),
    slug: Type.String(),
    name: Type.String(),
    playerName: Type.String(),
});
export const SessionResponseSchema = Type.Object({
    account: AccountSchema,
    worlds: Type.Array(WorldSummarySchema),
});
//# sourceMappingURL=auth.js.map